import * as React from "react";

function SvgReplayBird(props, ref) {
  return (
    <svg
      viewBox="0 0 30.7 34.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="ReplayBird_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={0}
        y1={18.538}
        x2={30.76}
        y2={18.538}
        gradientTransform="matrix(1 0 0 -1 0 35.995)"
      >
        <stop offset={0} stopColor="#ff8b0f" />
        <stop offset={1} stopColor="#ff3f05" />
      </linearGradient>
      <path
        d="M29.8 15.8L2.9.3C2-.3.8 0 .3 1c-.2.3-.3.6-.3.9V33c0 1.1.9 1.9 1.9 1.9.3 0 .7-.1 1-.3l2.2-1.2c1.2-3.1 1.7-6.5 1.7-9.8 0 0-1-8.4 6-10.5 1.2-.4 2.4-.4 3.6 0 1.6.6 2.7 2.1 3 3.8 1.3 0 2.5.6 3.5 1.5 0 0-7.4.1-8.9 8.3-.1.6-.2 1.2-.1 1.8L30 19.2c.9-.5 1.2-1.7.7-2.6-.4-.4-.6-.6-.9-.8zM7.7 11c.1-.2.4-.3.6-.2.6.3 2.4 1.7 2.1 1.7-.9.1-1.8-.2-2.5-.7-.2-.1-.5-.3-.2-.8zm2.9 2.5c-.7.5-1.6.7-2.4.7-.2 0-.6 0-.6-.6 0-.3.2-.5.4-.5.7-.1 2.9.2 2.6.4zm.5-1.6c-.7-.6-1.1-1.4-1.2-2.3-.1-.2-.2-.6.4-.7.3-.1.5.1.6.3.2.7.4 3 .2 2.7zm1.1.7c-.3-.7-.4-1.6-.2-2.4 0-.2.1-.6.7-.4.2 0 .4.2.4.5-.2.6-.8 2.6-.9 2.3z"
        fill="url(#ReplayBird_svg__a)"
      />
      <linearGradient
        id="ReplayBird_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={14.3}
        y1={19.317}
        x2={15.38}
        y2={19.317}
        gradientTransform="matrix(1 0 0 -1 0 35.995)"
      >
        <stop offset={0} stopColor="#ff8b0f" />
        <stop offset={1} stopColor="#ff3f05" />
      </linearGradient>
      <path
        d="M15.4 16.7c0-.3-.3-.5-.6-.5s-.5.3-.5.6.3.5.6.5c.3-.1.5-.3.5-.6z"
        fill="url(#ReplayBird_svg__b)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgReplayBird);
